<template>
  <div class="help-center">
    <self-service></self-service>
    <common-question></common-question>
    <question-category></question-category>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import QuestionCategory from './QuestionCategory/QuestionCategoryBackUp'
import CommonQuestion from './CommonQuestion/CommonQuestion'
import SelfService from './SelfService/SelfService'

export default {
  name: 'HelpCenter',
  created() {
    native.setTitle({
      title: '客服中心'
    })
    lego.send({
      pagetype: 'ZZUP_HELPCENTER_BACKUP',
      actiontype: 'PAGE_SHOW',
      backup: {
        from: this.from
      }
    })
  },
  components: {
    SelfService,
    CommonQuestion,
    QuestionCategory
  }
}
</script>

<style lang="less" scoped>
  @import 'HelpCenter.less';
</style>
